import axios from 'axios'
import CustomButton from 'components/Buttons/CustomButton'
import LoadingV2 from 'components/LoadingV2'
import { getMetaContent } from 'helpers'
import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Container, Input } from 'reactstrap'
import LoadingAnimation from '../../components/LoadingAnimation'
import { apiEndpoint } from '../../utility/Utils'

const TncView = () => {
  const location = useLocation()
  const dataState = location.state
  const [htmlContent, setHtmlContent] = useState('')
  const [link, setLink] = useState('')
  const [email, setEmail] = useState('')
  const [agree, setAgree] = useState(false)
  const [loadingTnc, setLoadingTnc] = useState(false)
  const [loading, setLoading] = useState(false)
  const [version, setVersion] = useState(0)

  const iframeRef = useRef(null)

  const navigate = useNavigate()

  const fetchData = async () => {
    setLoadingTnc(true)
    try {
      const url = dataState?.isNewLogin
        ? `${apiEndpoint}/api/v1/public/tnc`
        : `${apiEndpoint}/api/v1/public/tnc?link=${link}&email=${encodeURIComponent(email)}`
      const dataRes = await axios.get(url, {
        headers: {
          Accept: 'application/json',
          'User-Agent': 'PasarMIKRO',
          ...(dataState?.isNewLogin && {
            Authorization: 'd2hhdHNhcHBXZWJob29rOlBNWFlXQUlTYW5kQm94',
          }),
        },
      })
      setHtmlContent(dataRes.data)
      setVersion(Number(dataRes?.headers?.['tnc-version']))
    } catch {
      // Error fetching TnC
    } finally {
      setLoadingTnc(false)
    }
  }

  const handleVerif = async ({ userConsent }) => {
    try {
      setLoading(true)
      const resp = await axios.get(
        `${apiEndpoint}/api/v1/bussines/email-verification?link=${link}&userconsent=${version}`,
      )
      if (resp.status === 200) {
        if (resp?.data?.status === 'VERIFIED') {
          navigate('/sukses-verifikasi')
        } else {
          fetchData()
        }
      } else {
        setLoading(false)
      }
    } catch {
      // Error verifying
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const url = new URL(window.location)
    const params = new URLSearchParams(url.search)
    const linkValue = params.get('link')
    const emailValue = params.get('email')

    if (linkValue) {
      setLink(linkValue)
    }
    if (emailValue) {
      setEmail(emailValue)
    }
  }, [])

  useEffect(() => {
    if (dataState?.isNewLogin) {
      fetchData()
    } else if (link && email && !dataState?.isNewLogin) {
      handleVerif({ userConsent: 0 })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [link, email, dataState])

  const customIframeStyle = `<style>
    .legal-document {
      margin-left: 0 !important;
      margin-right: 0 !important;
      max-width: 100% !important;
      width: 100% !important;
      min-height: auto !important;
      box-sizing: border-box !important;
    }
    .legal-numbered-label {
      white-space: nowrap !important;
      width: auto !important;
      display: inline-block !important;
    }
    .legal-numbered-row {
      word-break: normal !important;
      overflow-wrap: break-word !important;
    }
    p, div, span {
      max-width: 100% !important;
      box-sizing: border-box !important;
    }
  </style>`

  const adjustIframeHeight = () => {
    if (iframeRef.current && iframeRef.current.contentDocument) {
      const doc = iframeRef.current.contentDocument
      if (doc.head && !doc.getElementById('tnc-custom-style')) {
        const styleEl = doc.createElement('style')
        styleEl.id = 'tnc-custom-style'
        styleEl.innerHTML = `
          .legal-document {
            margin-left: 0 !important;
            margin-right: 0 !important;
            max-width: 100% !important;
            width: 100% !important;
            min-height: auto !important;
            box-sizing: border-box !important;
          }
          .legal-numbered-label {
            white-space: nowrap !important;
            width: auto !important;
            display: inline-block !important;
          }
          .legal-numbered-row {
            word-break: normal !important;
            overflow-wrap: break-word !important;
          }
          p, div, span {
            max-width: 100% !important;
            box-sizing: border-box !important;
          }
        `
        doc.head.appendChild(styleEl)
      }
      const body = doc.body
      const html = doc.documentElement
      if (body && html) {
        const height = Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight,
        )
        iframeRef.current.style.height = `${height}px`
      }
    }
  }

  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.style.height = '0px'
    }
  }, [htmlContent])

  return (
    <div className="w-100 px-3">
      <div
        className="d-flex flex-column w-100 flex-grow-1 p-3"
        style={{
          overflow: 'auto',
          overflowX: 'hidden',
          maxWidth: '100%',
          minHeight: '60vh',
        }}
      >
        <div className="d-flex justify-content-center align-items-center my-2">
          <img
            alt={`${getMetaContent('og:title')} logo`}
            src={getMetaContent('og:image')}
            style={{ width: '100%', maxWidth: '150px', height: 'auto' }}
          />
        </div>

        {loadingTnc ? (
          <LoadingV2 />
        ) : (
          <>
            <iframe
              ref={iframeRef}
              srcDoc={htmlContent ? htmlContent + customIframeStyle : ''}
              width="100%"
              style={{
                overflow: 'hidden',
                maxWidth: '100%',
                border: 'none',
                minHeight: '50px',
              }}
              onLoad={adjustIframeHeight}
              data-testid="tnc-iframe"
            />

            {htmlContent ? (
              <Container>
                <div className="d-flex flex-column w-100">
                  {!dataState?.isNewLogin ? (
                    <>
                      <div className="d-flex align-items-center gap-2">
                        <Input
                          type="checkbox"
                          onChange={() => {
                            setAgree(!agree)
                          }}
                          data-testid="tnc-agree-checkbox"
                        />
                        <small>
                          Saya{' '}
                          <span style={{ fontWeight: 'bold' }}>({email}) </span>
                          menyetujui syarat dan ketentuan yang berlaku.
                        </small>
                      </div>
                      <div className="d-flex align-items-center gap-2 my-4">
                        <CustomButton
                          color="primary"
                          onClick={() => {
                            handleVerif({ userConsent: 1 })
                          }}
                          disabled={!agree || loading}
                          testId="tnc-verify-button"
                        >
                          Verifikasi
                        </CustomButton>
                        {loading ? <LoadingAnimation size="sm" data-testid="tnc-loading-indicator" /> : null}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </Container>
            ) : (
              <></>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default TncView